const { isDataURL } = require('../../../../helpers/dataUrl');
const Element = require('./abstract/element');
const ShapeGetter = require('./shape');

module.exports = Image;

function Image () {}

Image.prototype = new Element();
Image.prototype.constructor = Image;

Image.prototype.initialize = function () {
  Element.prototype.initialize.call(this);

  this.structure = _.extend(this.structure, {
    source: { url: null },
    flipped: null,
    filter: {
      // TODO
    },
    background_removed: false,
    crop_area: [{
      position: {
        x: null,
        y: null
      },
      size: {
        width: null,
        height: null
      },
      type: null
    }]
  });
};

Image.prototype.getSourceUrl = function () {
  const url = this.element.getAttribute('xlink:href');
  return isDataURL(url) ? '<data>' : url;
};

Image.prototype.getFlipped = function () {
  return {
    vertical: $(this.element).hasClass(INKIVE.C.FLIP_IMAGE.VERTICAL),
    horizontal: $(this.element).hasClass(INKIVE.C.FLIP_IMAGE.HORIZONTAL)
  };
};

Image.prototype.getCropArea = function () {
  const shapes = {};
  const clipPath = this.element.getAttribute('clip-path');

  if (!clipPath) return shapes;

  const clipID = clipPath.match(/url\("?([^")]*)"?\)/)[1];

  $(clipID).children('.layoutClipper').each(function (index, elem) {
    shapes[index] = new ShapeGetter();
    shapes[index].element = elem;
  });

  return shapes;
};

Image.prototype.getBackgroundRemoved = function () {
  return this.element && this.element.getAttribute('data-background-removed');
};
